const TIMEZONES = {
    CHICAGO: 'America/Chicago',
    EST: 'EST',
    GMT: 'GMT',
    LOS_ANGELES: 'America/Los_Angeles',
    NEW_YORK: 'America/New_York',
    PST: 'PST',
};

export default TIMEZONES;
